module.exports = __webpack_public_path__ + "media/images/career_camp/2023/count_3-805545e7e6c8370dd78541213b69a374.svg";